export default __webpack_public_path__ + "static/media/litho-demo-creative-agency.8c5431ef.jpg";